exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2IwjXWsBof1LEMlX5rjY6x{width:300px;height:71px}._1QvD6qjp1cCyQX1rPCvklr{display:none!important}", ""]);

// exports
exports.locals = {
	"consentContainer": "_2IwjXWsBof1LEMlX5rjY6x",
	"hiddenContainer": "_1QvD6qjp1cCyQX1rPCvklr"
};